var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",style:({
    width: _vm.percent + '%',
    height: _vm.height,
    'background-color': _vm.canSuccess ? _vm.color : _vm.failedColor,
    opacity: _vm.show ? 1 : 0
  })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330767c4","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 1274
// module chunks = 1